angular.module( 'acme.view.application.passes.create.settings', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.directive.integer',
  'acme.view.application.passes.create.settings.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var passesCreateSettings = {
        name: 'application.passes.create.settings',
        url: '/settings',
        views: {
          "subview-main": {
            controller: 'PassesCreateSettingsController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/passes/create/settings/settings.tpl.html'
          }
        },
        data: {
          pageTitle: 'Create Pass Program Settings'
        }
      },
      passesEditSettings = {
        name: 'application.passes.edit.settings',
        url: '/settings',
        views: {
          "subview-main": {
            controller: 'PassesCreateSettingsController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/passes/create/settings/settings.tpl.html'
          }
        },
        data: {
          pageTitle: 'Edit Pass Program Settings'
        }
      };

    $stateProvider
      .state(passesCreateSettings)
      .state(passesEditSettings);
});
